import * as React from 'react'
import {Link} from 'gatsby'

export default ({contrast = false}: {contrast?: boolean}) => (
  <Link to="/">
    <svg
      width="100%"
      viewBox="0 0 85 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.022 16V1.106H17.326V8.476L5.512 1.106H0.65V16H4.346V4.494L17.326 12.634V16H21.022ZM40.2538 10.522C39.7478 12.326 38.2958 13.492 33.9398 13.492C29.0118 13.492 27.6698 12.216 27.6698 8.564C27.6698 4.912 29.0118 3.636 33.9398 3.636C38.1638 3.636 39.6818 4.56 40.1658 6.54L43.6858 5.418C42.2558 1.832 39.3958 0.644 33.9398 0.644C27.2518 0.644 23.7758 2.58 23.7758 8.564C23.7758 14.548 27.2518 16.484 33.9398 16.484C39.4178 16.484 42.5198 14.878 43.7518 11.644L40.2538 10.522Z"
        fill={contrast ? '#FFFFFF' : '#504478'}
      />
      <path
        d="M62.6089 10.874V7.904H49.9149V3.944H62.7189V1.106H46.1969V16H49.9149V10.874H62.6089ZM84.1771 16L76.3231 7.992L83.7811 1.106H79.0071L73.9911 6.012L69.1511 1.106H63.9811L71.4611 8.344L63.6071 16H68.4251L73.7931 10.588L79.0511 16H84.1771Z"
        fill="#F95986"
      />
    </svg>
  </Link>
)
